import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#003366] mx-auto"></div>
      <p className="mt-4 text-slate-600">Carregando...</p>
    </div>
  </div>
);

const AccessDenied = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md">
      <div className="text-red-500 text-6xl mb-4">🔒</div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Acesso Negado</h2>
      <p className="text-gray-600 mb-4">Você não tem permissão para acessar esta página.</p>
      <a href="/dashboard" className="text-blue-600 hover:underline">Voltar ao Dashboard</a>
    </div>
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" />;

  return children;
};

// Somente Admin pode acessar
export const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" />;
  if (!isAdmin()) return <AccessDenied />;

  return children;
};

// Admin ou Supervisor podem acessar (para cadastros)
export const SupervisorRoute = ({ children }) => {
  const { user, loading, isAdmin, isSupervisor } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" />;
  if (!isAdmin() && !isSupervisor()) return <AccessDenied />;

  return children;
};

// Admin, Supervisor OU Secretaria podem acessar (para página de Secretarias)
export const SecretariaAccessRoute = ({ children }) => {
  const { user, loading, isAdmin, isSupervisor, isSecretaria } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" />;
  if (!isAdmin() && !isSupervisor() && !isSecretaria()) return <AccessDenied />;

  return children;
};

// Rota apenas para visualização (todos podem ver, mas não editar)
export const ViewOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" />;

  return children;
};